import React from 'react';
import { Calendar as CalendarIcon, Music, Wind } from 'lucide-react';
import { events } from '../data/mockData';

const EventsSection = () => {
  const getIconComponent = (iconName) => {
    switch (iconName) {
      case '🍹':
        return <CalendarIcon className="w-8 h-8" />;
      case '🎵':
        return <Music className="w-8 h-8" />;
      case '💨':
        return <Wind className="w-8 h-8" />;
      default:
        return <CalendarIcon className="w-8 h-8" />;
    }
  };

  return (
    <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #0A0015, #1A0520)' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <Music className="w-12 h-12 mx-auto mb-4 text-deep-violet" style={{ filter: 'drop-shadow(0 0 10px #8A2BE2)' }} />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Events & Specials
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-deep-violet to-neon-pink mx-auto rounded-full" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {events.map((event, index) =>
          <div
            key={event.id}
            className="glass-card p-8 text-center float-animation"
            style={{ animationDelay: `${index * 0.2}s` }}>

              <div className="text-neon-pink mb-4 flex justify-center" style={{ filter: 'drop-shadow(0 0 10px #FF00FF)' }}>
                {getIconComponent(event.icon)}
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                {event.name}
              </h3>
              
              <p className="text-white/70 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {event.description}
              </p>
              
              <div className="border-t border-neon-pink/20 pt-4 mt-4">
                <p className="text-neon-pink font-semibold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {event.day}
                </p>
                <p className="text-white/60 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {event.time}
                </p>
              </div>
            </div>
          )}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-white/70 text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Folge uns auf Instagram für aktuelle Events & Updates
          </p>
          <a
            href="https://www.instagram.com/saale_lounge?igsh=MXNtdWVoZHR5NjczNw=="
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block neon-button mt-4 !text-[#F7F7F7]">

            @saalelounge
          </a>
        </div>
      </div>
    </section>);

};

export default EventsSection;